export default "__VITE_ASSET__CL9r7jvo__"